import { ThemedTitle } from '@refinedev/antd';
import { env } from '@/config/env';

interface AppTitleProps {
  collapsed: boolean;
}

export const AppTitle = ({ collapsed }: AppTitleProps) => {
  return (
    <ThemedTitle
      collapsed={collapsed}
      text={env.APP_NAME}
      icon={
        <img
          src="/images/favicon-96x96.png"
          alt="Novelist"
          style={{ width: '24px', height: '24px', verticalAlign: 'top' }}
        />
      }
      wrapperStyles={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    />
  );
};
